import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import Linkify from 'linkifyjs/react'
import Bubble from './Bubble'

const TextWrapper = styled(Linkify)`
  white-space: pre-wrap;
  width: calc(100% - 16px);
`
const ShadowDiv = styled.div`
    opacity: .2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    background: #011;
`

const TextMessage = ({payload, isLeft, avatar, endOfBlock, createdAt, isDim}) => {
  const content = payload.text || payload.speech || ''
  const dim = isDim ? <ShadowDiv/> : null
  return (
    <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='85.5%'
      timestamp={createdAt}
      stampStyle='text'
    >
      {dim}
      <TextWrapper>{content}</TextWrapper>
    </Bubble>)
}

export default TextMessage

TextMessage.defaultProps = {
  isLeft: false,
  endOfBlock: false,
  isDim: false
}

TextMessage.propTypes = {
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object.isRequired,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date).isRequired,
  isDim: PropTypes.bool
}
